import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from '../../../services/api'
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";
import UTILS from "../../../services/utils";

const AdminApiService = new AdminApi();
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            selectedImage: null,
            selectedImagePreview: null,
            showAddCategory: true,
            imageUrl: null,
            idToEdit: null,
            title: LocService.t('label_ci_event_add'),
            allCustomCategories: [],
            selectedCustomCategories: [],
            isAction: false,
            useCreditsToBuyForShop: false,
            newFieldItem: '',
            fromDate: null,
            toDate: null,
            fieldsItems: [],
            model: {
                orderNumber: 0,
                stockNumber: 0,
                name: '',
                enName: '',
                shortDescription: '',
                enShortDescription: '',
                longDescription: '',
                enLongDescription: '',
                imageHeader: null,
                imageMain: '',
                orderUuid: '',
                type: 'EVENT',
                price: null,
                discount: null,
                location: null,
                creditForUse: 1,
                isCreditType: false,
                additionalInfo: {
                    fields: '',
                    date: '',
                    toDate: '',
                    price: '',
                    location: ''
                },
                locations: null

            },

        }
    },
    methods: {
        addTraining: addTraining,
        editTraining: editTraining,
        getTrainingInfoById: getTrainingInfoById,
        editTrainingFromApi: editTrainingFromApi,
        loadTextFromFile: loadTextFromFile,
        reset: reset,
        isSelected: isSelected,
        populateItemToEdit: populateItemToEdit,
        addNewField: addNewField,
        removeField: removeField,
        formatDate: formatDate,
        getChipClass: getChipClass,
        clickSelectCustomCategory: clickSelectCustomCategory,
        addTrainingFromApi: addTrainingFromApi,
        uploadPhoto: uploadPhoto,
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.allCustomCategories = session.getConfig().customCategories.split(";");
        this.useCreditsToBuyForShop = session.getConfig().useCreditsToBuyForShop != null ? session.getConfig().useCreditsToBuyForShop : false;
        this.idToEdit = this.$route.query.id;
        this.isAction = this.$route.query.action == null ? false : this.$route.query.action;
        if(this.idToEdit != null){
            this.title = this.isAction ? LocService.t('label_action_for_item') : LocService.t('label_ci_event_edit');
            this.getTrainingInfoById()
        }
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
    }
}

function removeField(item) {
    this.fieldsItems = this.fieldsItems.filter( i => i !== item)
}

function addNewField(){
    if(this.newFieldItem == null || this.newFieldItem.length === 0) return;
    if(this.fieldsItems.includes(this.newFieldItem)) return;
    this.fieldsItems.push(this.newFieldItem);
    this.newFieldItem = '';
}

function formatDate(dateString) {
    let parts = dateString.split("-");
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
}

function getTrainingInfoById(){
    let _self = this;
    AdminApiService.getCompanyInfoById(this.idToEdit)
        .then((response) => {
            _self.populateItemToEdit(response)
        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function populateItemToEdit(response){
    let _self = this;
    let addInfo = JSON.parse(response.data.additionalInfo)
    _self.imageUrl = response.data.imageMain
    _self.model.name = response.data.name
    _self.model.enName = response.data.enName
    _self.model.orderNumber = response.data.orderNumber
    _self.model.stockNumber = response.data.stockNumber
    _self.model.shortDescription = response.data.shortDescription
    _self.model.enShortDescription = response.data.enShortDescription
    _self.model.longDescription = response.data.longDescription
    _self.model.enLongDescription = response.data.enLongDescription
    _self.model.imageMain = response.data.imageMain
    _self.model.creditForUse = response.data.creditForUse
    _self.model.isCreditType = response.data.isCreditType
    _self.model.additionalInfo.fields = addInfo.fields
    _self.model.additionalInfo.price = addInfo.price
    _self.model.additionalInfo.location = addInfo.location
    if(addInfo.date != null){
        _self.model.additionalInfo.date = this.formatDate(addInfo.date)
        _self.fromDate = this.formatDate(addInfo.date)
    }else{
        _self.model.additionalInfo.date = null;
        _self.fromDate = null;
    }
    if(addInfo.toDate != null){
        _self.model.additionalInfo.toDate = this.formatDate(addInfo.toDate)
        _self.toDate = this.formatDate(addInfo.toDate)
    }else{
        _self.model.additionalInfo.toDate = null;
        _self.toDate = null;
    }
    _self.fieldsItems = addInfo.fields != null ? addInfo.fields.split(";").filter(i => i.length > 0) : []
    _self.selectedCustomCategories = response.data.locations == null ? [] : response.data.locations.split(";").filter(e => e.length > 0)
}


function addTraining() {
    if(this.idToEdit != null){
        this.editTraining();
        return;
    }
    let _self = this;
    if (_self.model.name === '' || _self.model.shortDescription === '' || (!this.isAction && _self.selectedImage == null)) {
        swal(LocService.t("label_error"), LocService.t('label_ci_training_required'), 'error')
        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });

    if(_self.isAction){
        _self.addTrainingFromApi(_self.model.imageMain);
    }else{
        _self.uploadPhoto(false);
    }

}

function editTraining(){
    let _self = this;
    if (_self.model.name === '' || _self.model.shortDescription === '' ) {
        swal(LocService.t("label_error"), LocService.t('label_ci_training_required'), 'error')
        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    if(_self.selectedImage != null){
        _self.uploadPhoto(true)
    }else{
        _self.editTrainingFromApi(_self.model.imageMain)
    }
}

function uploadPhoto(isEdit) {
    let _self = this;
    AdminApiService.uploadImageCompanyInfo(this.selectedImage)
        .then((response) => {
            if(isEdit){
                _self.editTrainingFromApi(response.data.url)
            }else{
                _self.addTrainingFromApi(response.data.url);
            }

        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function editTrainingFromApi(url) {
    this.model.additionalInfo.fields = UTILS.formatFieldItemsForEvent(this.fieldsItems)
    var calendarTimestampFrom = Date.parse(this.fromDate);
    var calendarTimestampTo = Date.parse(this.toDate);
    if(isNaN(calendarTimestampFrom)){
        this.model.additionalInfo.date = null;
    }else{
        this.model.additionalInfo.date = this.$moment(this.fromDate).format('DD-MM-YYYY');
    }

    if(isNaN(calendarTimestampTo)){
        this.model.additionalInfo.toDate = null;
    }else{
        this.model.additionalInfo.toDate = this.$moment(this.toDate).format('DD-MM-YYYY');
    }
    let _self = this;
    let modelToSend = {
        id: this.idToEdit,
        name: this.model.name,
        enName: this.model.enName,
        orderNumber: this.model.orderNumber <= 0 ? null : this.model.orderNumber,
        stockNumber: this.model.stockNumber,
        shortDescription: this.model.shortDescription,
        enShortDescription: this.model.enShortDescription,
        longDescription: this.model.longDescription,
        enLongDescription: this.model.enLongDescription,
        additionalInfo: JSON.stringify(this.model.additionalInfo),
        imageHeader: null,
        imageMain: url,
        type: 'EVENT',
        locations: UTILS.formatSelectedLocations(_self.selectedCustomCategories)
    }
    AdminApiService.updateCompanyInfoTraining(modelToSend)
        .then((response) => {
            _self.reset();
            swal(LocService.t("label_success"), LocService.t('label_ci_item_success_add'), 'success')
            _self.$router.push(CONFIG_COMPANY.HOME + "?selectedButton=EVENT");
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function addTrainingFromApi(url) {
    this.model.additionalInfo.fields = UTILS.formatFieldItemsForEvent(this.fieldsItems)
    var calendarTimestampFrom = Date.parse(this.fromDate);
    var calendarTimestampTo = Date.parse(this.toDate);
    if(isNaN(calendarTimestampFrom)){
        this.model.additionalInfo.date = null;
    }else{
        this.model.additionalInfo.date = this.$moment(this.fromDate).format('DD-MM-YYYY');
    }
    if(isNaN(calendarTimestampTo)){
        this.model.additionalInfo.toDate = null;
    }else{
        this.model.additionalInfo.toDate = this.$moment(this.toDate).format('DD-MM-YYYY');
    }
    let _self = this;
    let modelToSend = {
        name: this.model.name,
        enName: this.model.enName,
        shortDescription: this.model.shortDescription,
        orderNumber: this.model.orderNumber <= 0 ? null : this.model.orderNumber,
        stockNumber: this.model.stockNumber,
        enShortDescription: this.model.enShortDescription,
        longDescription: this.model.longDescription,
        enLongDescription: this.model.enLongDescription,
        additionalInfo: JSON.stringify(this.model.additionalInfo),
        imageHeader: null,
        imageMain: url,
        type: 'EVENT',
        parentOrderUuid: this.isAction ? this.model.orderUuid : null,
        locations: UTILS.formatSelectedLocations(_self.selectedCustomCategories)
    }
    AdminApiService.addCompanyInfoTraining(modelToSend)
        .then((response) => {
            _self.reset();
            swal(LocService.t("label_success"), LocService.t('label_ci_training_success_add'), 'success')
            _self.$router.push(CONFIG_COMPANY.HOME + "?selectedButton=EVENT");
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function reset() {
    this.selectedImage = null
    this.selectedImagePreview = null
    this.imageUrl = null
    this.model = {
        stockNumber: 0,
        name: '',
        enName: '',
        shortDescription: '',
        enShortDescription: '',
        longDescription: '',
        enLongDescription: '',
        imageHeader: null,
        imageMain: '',
        type: 'EVENT',
        locations: null
    }
}


function loadTextFromFile(ev) {
    var i = 0;
    for (i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        if (file.size > 5000000) {
            alert(this.locale.t('label_max_size_picture'))
            return
        }
        const reader = new FileReader();
        this.selectedImage = file;
        this.selectedImagePreview = URL.createObjectURL(file);
        reader.onload = e => {
            // console.log(e.target.result);
            // _self.files.push(e.target.result);
        }

        reader.readAsDataURL(file);

    }

}

function getChipClass(item) {
    if (this.selectedCustomCategories.includes(item)) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item) {
    return this.selectedCustomCategories.includes(item)
}

function clickSelectCustomCategory(item) {
    if (this.selectedCustomCategories.includes(item)) {
        this.selectedCustomCategories = this.selectedCustomCategories.filter(e => e !== item)
    } else {
        this.selectedCustomCategories.push(item)
        if(this.selectedCustomCategories.length === this.allCustomCategories.length){
            this.selectedCustomCategories = []
        }
    }
}






// WEBPACK FOOTER //
// ./src/components/Home/Add/AddEventInfo.js